import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import SEO from "@/components/SEO";
import CTASection from "@/components/CTASection";
import FAQAccordion from "@/components/FAQAccordion";
import { FAQ_PAGE } from "@/data/siteContent";

export default function FAQ() {
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQ_PAGE.flatMap((cat) =>
      cat.items.map((i) => ({ "@type": "Question", name: i.q, acceptedAnswer: { "@type": "Answer", text: i.a } }))
    ),
  };

  return (
    <>
      <SEO
        title="Life Insurance FAQs | 1907 Insurance Group"
        description="Plain-language answers about final expense and term life insurance, health questions, premiums, beneficiaries, and working with an independent agent."
        jsonLd={faqJsonLd}
      />
      <PageHero
        eyebrow="Frequently Asked Questions"
        title="Straight Answers, Without the Fine-Print Voice"
        intro="General answers to the questions we hear most. The details of any policy always come from the issuing insurance company."
      />
      <section className="py-16 md:py-24" data-testid="faq-page-content">
        <div className="container-site max-w-4xl space-y-16">
          {FAQ_PAGE.map((cat, i) => (
            <Reveal key={cat.category}>
              <h2 className="text-2xl sm:text-3xl tracking-tight" data-testid={`faq-category-${i}`}>{cat.category}</h2>
              <div className="mt-6">
                <FAQAccordion items={cat.items} testid={`faq-cat-${i}`} />
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <CTASection heading="Didn't See Your Question?" text="Call Michael and ask directly. There is no charge for a conversation, and no such thing as a silly question." />
    </>
  );
}
